import AllProductsTab from './all-products'
import FootwarTab from './footwear'
import BlousesTab from './blouses'
import PantsTab from './pants'

export const MainTabWoman = () => {
  return {
    AllProductsTab,
    FootwarTab,
    BlousesTab,
    PantsTab
  }
}
